"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var file_saver_1 = require("file-saver");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
var actions_1 = __importDefault(require("../../../../../../../app/components/pages/RootPage/actions"));
var download_svg_1 = __importDefault(require("../../assets/download.svg"));
var requests_1 = require("../../../../../../../app/util/requests");
var ie_1 = __importDefault(require("../../../../../../../app/components/BaseLayout/util/ie"));
var index_1 = require("../../../../index");
var ga_1 = require("../../../../../../../app/util/ga");
function downloadClicks(shortUrl, onError) {
    return __awaiter(this, void 0, void 0, function () {
        var offsetDays, url, response, data, clicksData, clicksArray, blob;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    offsetDays = 3650;
                    url = "/api/link-stats?url=".concat(shortUrl, "&offset=").concat(offsetDays);
                    return [4 /*yield*/, (0, requests_1.get)(url)];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        (0, ga_1.GAEvent)('Link stats CSV download', shortUrl, 'unsuccessful');
                        onError();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    clicksData = data.dailyClicks;
                    clicksArray = [['date', 'clicks\n']];
                    clicksData.forEach(function (c) { return clicksArray.push([c.date, "".concat(c.clicks, "\n")]); });
                    blob = new Blob([clicksArray.join('')], {
                        type: 'text/csv;charset=utf-8',
                    });
                    if ((0, ie_1.default)()) {
                        // @ts-ignore: `msSaveBlob` used for old IE versions has been removed as of TypeScript 4.4
                        navigator.msSaveBlob(blob, 'clicks.csv');
                    }
                    else {
                        (0, file_saver_1.saveAs)(blob, 'clicks.csv');
                    }
                    (0, ga_1.GAEvent)('Link stats CSV download', shortUrl, 'successful');
                    return [2 /*return*/];
            }
        });
    });
}
var useStyles = (0, makeStyles_1.default)(function () { return ({
    button: {
        display: 'flex',
        alignItems: 'center',
        border: 'none',
        padding: 0,
        outline: 0,
        background: 'transparent',
        cursor: 'pointer',
    },
    text: {
        padding: '5px 0',
        display: 'inline-block',
    },
    icon: {
        padding: '0 5px',
    },
}); });
function DownloadClicksButton() {
    var shortUrl = (0, index_1.useDrawerState)().relevantShortLink;
    var classes = useStyles();
    var dispatch = (0, react_redux_1.useDispatch)();
    var onError = function () {
        return dispatch(actions_1.default.setErrorMessage('Error downloading urls.'));
    };
    return (react_1.default.createElement("button", { className: classes.button, type: "button", onClick: function () { return downloadClicks(shortUrl, onError); } },
        react_1.default.createElement(Typography_1.default, { color: "primary", variant: "body2", className: classes.text }, "Download full link click statistics here"),
        react_1.default.createElement("img", { src: download_svg_1.default, alt: "download icon", "aria-hidden": true, className: classes.icon })));
}
exports.default = DownloadClicksButton;
